import React, { useEffect } from 'react';
import { BrowserRouter as Router, Switch, Redirect, Route } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import { observer } from 'mobx-react-lite';
import { Spinner, ToastManager as IMToastManager } from '@insurancemenu/imenu-components-lib';
import 'react-toastify/dist/ReactToastify.css';
import LoginPage from 'pages/LoginPage';
import Header from 'components/common/Header';
import RegistrationPage from 'pages/RegistrationPage';
import ForgotPasswordPage from 'pages/ForgotPasswordPage';
import ResetPasswordPage from 'pages/ResetPasswordPage';
import SelfRegistrationPage from 'pages/SelfRegistrationPage';
import { createStyles } from './globalStyles';
import { useRootStore } from './store/rootStore';

const App: React.FC = observer(() => {
  const rootStore = useRootStore();
  const { loading } = rootStore.loginSessionStore;

  const classes = createStyles();

  useEffect(() => {
    void rootStore.loginSessionStore.checkIfUserIsLoggedIn();
  }, []);

  useEffect(() => {
    const interval = setInterval(() => {
      void rootStore.loginSessionStore.requestRefreshTokenAsync();
    }, 300000); // 5 mins - 300 000 milliseconds
    return (): void => clearInterval(interval);
  }, []);

  return (
    <>
      {loading ? (
        <div className={classes.spinnerWrapper}>
          <Spinner />
        </div>
      ) : (
        <div className={classes.appWrapper}>
          <Router>
            <Header />
            <Switch>
              <Route exact path="/login" component={LoginPage} />
              <Route exact path="/registration" component={RegistrationPage} />
              <Route exact path="/forgot-password" component={ForgotPasswordPage} />
              <Route exact path="/reset-password" component={ResetPasswordPage} />
              <Route exact path="/self-registration/:groupId" component={SelfRegistrationPage} />
              <Route exact path="/">
                <Redirect to="/login" />
              </Route>
              <Route exact path="*">
                <Redirect to="/login" />
              </Route>
            </Switch>
          </Router>
        </div>
      )}

      <ToastContainer />
      <IMToastManager />
    </>
  );
});

export default App;
